<template>
    <div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Nombre</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Nombre"
                                readonly
                                type="text"
                                v-model="especialidad_json.nombre"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Código de integración</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-barcode"></i>
                                </span>
                            </div>
                            <input
                                placeholder="Código de integración"
                                readonly="readonly"
                                v-model="especialidad_json.UUID"
                                type="text"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label
                            >Confirmable (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir realizar la confirmación de las horas de esta especialidad."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                v-model="especialidad_json.confirmable"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Nombre Corto</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                placeholder="Nombre Corto"
                                type="text"
                                v-model="especialidad_json.nombre_corto"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Anulación hora telemedicina</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-clock"></i>
                                </span>
                            </div>
                            <input
                                placeholder="Hora anulación telemedicina"
                                type="text"
                                v-model="especialidad_json.anulacion_hora_tlm"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group" style="display:none;"></div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="hr-line-dashed"></div>
                    <h2>Video Explicativo</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Etiqueta del video (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Texto descriptivo que se mostrará como link en los vouchers."
                                ><i class="fa fa-question-circle"></i></a>)</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                placeholder="Ej: Ver video explicativo"
                                type="text"
                                v-model="especialidad_json.label_video_explicativo"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                        <label>URL del video explicativo (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Enlace al video explicativo asociado a esta especialidad. Se mostrará en los vouchers de pacientes."
                                ><i class="fa fa-question-circle"></i></a>)</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-video"></i>
                                </span>
                            </div>
                            <input
                                placeholder="https://..."
                                type="url"
                                v-model="especialidad_json.url_video_explicativo"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="hr-line-dashed"></div>
                    <h2>Encuestas Máximas</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-striped table-bordered w-100">
                        <thead>
                            <tr>
                                <th>Establecimiento</th>
                                <th>Disponibles</th>
                                <th>Encuestas Asignadas</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="establecimiento in establecimientos_encuestas_asignadas"
                                :key="establecimiento.id"
                            >
                                <td>{{ establecimiento.nombre }}</td>
                                <td>{{ establecimiento.encuestas_maximas }}</td>
                                <td>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="
                                            establecimiento.encuestas_asignadas
                                        "
                                        :key="establecimiento.id"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="hr-line-dashed"></div>

            <hr v-if="list.length > 0" />
            <div
                class="row"
                v-for="(item, index) in list"
                :key="index"
                style="border-bottom: 1px solid #bfbfbfee; margin-bottom: 16px"
            >
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Establecimiento {{ index + 1 }}</label>
                        <div class="input-group">
                            <multiselect
                                placeholder="Selecciona establecimiento"
                                label="nombre"
                                :multiple="true"
                                :taggable="true"
                                track-by="id"
                                v-model="item.establecimientos"
                                :options="establecimientos_list"
                            ></multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Estrategia {{ index + 1 }}</label>
                        <div class="input-group">
                            <select
                                class="custom-select"
                                v-model="item.estrategia"
                            >
                                <option disabled value="">
                                    Seleccione un elemento
                                </option>
                                <option
                                    v-for="(
                                        estrategia, index3
                                    ) in estrategias_list"
                                    :key="index3"
                                    v-bind:value="estrategia.id"
                                >
                                    {{ estrategia.nombre }}
                                </option>
                            </select>
                            <!-- <input placeholder="Abreviatura" v-model="item.estrategia" type="text" class="form-control" /> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Tipo Cita {{ index + 1 }}</label>
                        <div class="input-group">
                            <multiselect
                                placeholder="Selecciona tipo cita"
                                label="abrev"
                                :multiple="true"
                                :taggable="true"
                                track-by="id"
                                v-model="item.tipo_citas"
                                :options="tipo_cita_list"
                            ></multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Eliminar</label>
                        <div class="input-group">
                            <button
                                class="btn btn-secondary"
                                @click="eliminar(index)"
                            >
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <a href="javascript:void(0)" @click="add"
                        >Añadir Estrategia</a
                    >
                </div>
            </div>

            <!-- Indicaciones Correo Section moved to bottom -->
            <div class="row">
                <div class="col">
                    <div class="hr-line-dashed"></div>
                    <h2>Indicaciones Correo</h2>
                    <div class="hr-line-dashed"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="dropzone" id="dropzoneEspecialidad">
                    </div>
                </div>
            </div>
        </div>

        <div class="ibox-footer">
            <div class="row">
                <div class="col-md-4 offset-md-8">
                    <div class="btn-group float-right">
                        <b-overlay :show="buttonDisable" rounded="sm">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                @click="save"
                            >
                                <i class="fal fa-save"></i> Guardar
                            </button>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
    components: { Multiselect },
    props: [
        "especialidad",
        "establecimientos",
        "estrategias",
        "tipo_cita",
        "id",
        "test_ab",
        "establecimientos_encuestas",
        "encuestas_maximas",
    ],
    data() {
        return {
            especialidad_json: {
                archivos_adjuntos: [],
            },
            list: [],
            establecimientos_list: [],
            estrategias_list: [],
            tipo_cita_list: [],
            test_ab_list: [],
            encuestas_asignadas: [],
            establecimientos_encuestas_asignadas: [],
            encuestas_maximas_especialidad: [],
            buttonDisable: false,
            archivos_nuevos: [],
            eliminar_archivos: [],
        };
    },
    mounted() {
        this.especialidad_json = JSON.parse(this.especialidad);
        this.estrategias_list = JSON.parse(this.estrategias);
        this.establecimientos_list = JSON.parse(this.establecimientos);
        this.tipo_cita_list = JSON.parse(this.tipo_cita);
        const encuestas_maximas = JSON.parse(this.encuestas_maximas);
        this.establecimientos_encuestas_asignadas = JSON.parse(
            this.establecimientos_encuestas
        );
        this.establecimientos_encuestas_asignadas =
            this.establecimientos_encuestas_asignadas.map((el) => {
                const encuestas_maximas_asignadas =
                    encuestas_maximas.find(
                        (it) => it.id_establecimiento == el.id
                    )?.encuestas_max ?? 0;
                el["encuestas_maximas"] =
                    el.encuestas_maximas + encuestas_maximas_asignadas;
                el["encuestas_asignadas"] = encuestas_maximas_asignadas;
                return el;
            });
        let establecimientos = [];
        let tipo_citas = [];
        let temp = [];
        console.log(JSON.parse(this.test_ab));
        this.list = JSON.parse(this.test_ab).map((element) => {
            establecimientos = [];
            tipo_citas = [];
            const map_establecimientos = new Map();
            const map_tipo_cita = new Map();
            for (const item of element.establecimientos) {
                if (!map_establecimientos.has(item.id_establecimiento)) {
                    map_establecimientos.set(item.id_establecimiento, true); // set any value to Map
                    establecimientos.push(item.establecimiento);
                }
                // console.log(item);
                if (!map_tipo_cita.has(item.id_tipocita)) {
                    map_tipo_cita.set(item.id_tipocita, true); // set any value to Map
                    tipo_citas.push(item.tipo_cita);
                }
            }
            return {
                establecimientos: establecimientos,
                estrategia: element.estrategia.id,
                tipo_citas: tipo_citas,
                id: element.id,
            };
        });

        console.log(this.list);

        // Initialize Dropzone
        var vm = this;
        this.dropzone = new window.Dropzone("#dropzoneEspecialidad", {
            url: "/admin/configurar/upload",
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 5,
            maxFiles: 10,
            addRemoveLinks: true,
            dictDefaultMessage: "<strong>Arrastra tus archivos aquí o haz clic para cargar.</strong>",
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            init: function() {
                var myDropzone = this;

                function getIconClass(filename) {
                    var ext = filename.split('.').pop().toLowerCase();
                    switch (ext) {
                        case 'pdf': return 'fa-file-pdf';
                        case 'doc':
                        case 'docx': return 'fa-file-word';
                        case 'xls':
                        case 'xlsx': return 'fa-file-excel';
                        case 'ppt':
                        case 'pptx': return 'fa-file-powerpoint';
                        case 'zip':
                        case 'rar': return 'fa-file-archive';
                        case 'txt': return 'fa-file-alt';
                        case 'csv': return 'fa-file-csv';
                        default: return 'fa-file';
                    }
                }

                this.on("addedfile", function(file) {
                    if (file.type && !file.type.match(/image.*/)) {
                        var iconClass = getIconClass(file.name);
                        var dzImage = file.previewElement.querySelector(".dz-image");
                        if (dzImage) {
                            dzImage.innerHTML = '<div class="text-center" style="padding-top: 20px;"><i class="fal ' + iconClass + '" style="font-size: 60px; color: #676a6c;"></i></div>';
                            dzImage.style.backgroundColor = 'transparent';
                        }
                    }
                });

                // Mock existing files
                if (vm.especialidad_json.archivos_adjuntos) {
                    vm.especialidad_json.archivos_adjuntos.forEach(function(file) {
                        var mockFile = { name: file.name, size: file.size, path: file.path, isMock: true, url: file.url, type: file.mime };
                        myDropzone.emit("addedfile", mockFile);
                        
                        if(file.url && file.mime && file.mime.match(/^image\//)) {
                            myDropzone.emit("thumbnail", mockFile, file.url);
                        }

                        myDropzone.emit("complete", mockFile);
                        myDropzone.files.push(mockFile);

                        // Click to open existing
                        if(file.url) {
                            mockFile.previewElement.style.cursor = "pointer";
                            mockFile.previewElement.addEventListener("click", function(e) {
                                if (e.target.hasAttribute('data-dz-remove') || e.target.closest('[data-dz-remove]')) {
                                    return;
                                }
                                window.open(file.url, '_blank');
                            });
                        }
                    });
                }

                this.on("success", function(file, response) {
                     // Store file metadata
                     file.serverData = response;
                     vm.archivos_nuevos.push(response);

                     // Add click listener
                     if(response.url) {
                        file.previewElement.style.cursor = "pointer";
                        file.previewElement.addEventListener("click", function(e) {
                            if (e.target.hasAttribute('data-dz-remove') || e.target.closest('[data-dz-remove]')) {
                                return;
                            }
                            window.open(response.url, '_blank');
                        });
                     }
                });
                   
                this.on("removedfile", function(file) {
                    if (file.isMock) {
                         vm.eliminar_archivos.push(file.path);
                    } else if (file.serverData) {
                        // Remove from archivos_nuevos
                        vm.archivos_nuevos = vm.archivos_nuevos.filter(f => f.path !== file.serverData.path);
                    }
                });
            }
        });
    },
    methods: {
        add() {
            let x = {
                establecimientos: this.establecimientos_list,
                estrategia: "",
                tipo_citas: [],
                id: null,
            };
            this.list.push(x);
        },
        save() {
            this.buttonDisable = true;
            // this.especialidad_json = this.list;
            let flag = true;
            let establecimientos = [];
            let array_objects = [];
            let temp = [];

            console.log(this.list);
            this.especialidad_json["id"] = this.id;
            this.especialidad_json["list"] = this.list.map((element, index) => {
                if (!this.filtrar_vacio(element, index) || !flag) {
                    this.buttonDisable = false;
                    flag = false;
                    return;
                }
                establecimientos = [];
                if (flag)
                    for (const element2 of element.establecimientos) {
                        establecimientos.push(element2.id);

                        for (
                            let index2 = 0;
                            index2 < element.tipo_citas.length;
                            index2++
                        ) {
                            let obj = {
                                id_establecimiento: element2.id,
                                establecimiento_nombre: element2.nombre,
                                id_tipo_cita: element.tipo_citas[index2].id,
                                tipo_cita_abrev:
                                    element.tipo_citas[index2].abrev,
                                indice: index + 1,
                            };
                            temp = array_objects.filter((filtro) => {
                                return (
                                    filtro.id_establecimiento ==
                                        obj.id_establecimiento &&
                                    filtro.id_tipo_cita == obj.id_tipo_cita
                                );
                            });

                            if (temp.length > 0) {
                                this.$swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: "Oops...",
                                    text:
                                        'ERROR "' +
                                        temp[0].establecimiento_nombre +
                                        '" se repite con el mismo tipo de cita en establecimiento ' +
                                        temp[0].indice +
                                        " y establecimiento " +
                                        obj.indice +
                                        "!",
                                    showConfirmButton: true,
                                    timer: 5000,
                                });
                                this.buttonDisable = false;
                                flag = false;
                                break;
                            } else {
                                array_objects.push(obj);
                            }
                        }

                        if (!flag) break;
                    }
                return {
                    establecimientos: establecimientos,
                    estrategia: element.estrategia,
                    tipo_citas: element.tipo_citas.map((element3) => {
                        return element3.id;
                    }),
                    id: element.id,
                };
            });
            // console.log(array_objects);
            const establecimientos_superados =
                this.establecimientos_encuestas_asignadas.filter(
                    (el) => el.encuestas_asignadas > el.encuestas_maximas
                );
            if (establecimientos_superados.length > 0) {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "Encuestas asignadas superan la cantidad disponibles en el establecimiento " +
                        establecimientos_superados[0].nombre,
                    showConfirmButton: true,
                    timer: 3000,
                });
                this.buttonDisable = false;
                return;
            }

            this.especialidad_json.encuestas_asignadas =
                this.establecimientos_encuestas_asignadas.map((el) => {
                    return {
                        id_establecimiento: el.id,
                        encuestas_asignadas: el.encuestas_asignadas ?? null,
                    };
                });
            // console.log(this.especialidad_json);
            if (!flag) {
                this.buttonDisable = false;
                return;
            }

            let formData = new FormData();
            formData.append("id", this.especialidad_json.id);
            formData.append(
                "confirmable",
                this.especialidad_json.confirmable ? 1 : 0
            );
            formData.append(
                "nombre_corto",
                this.especialidad_json.nombre_corto || ""
            );
            formData.append(
                "anulacion_hora_tlm",
                this.especialidad_json.anulacion_hora_tlm || ""
            );
            formData.append(
                "label_video_explicativo",
                this.especialidad_json.label_video_explicativo || ""
            );
            formData.append(
                "url_video_explicativo",
                this.especialidad_json.url_video_explicativo || ""
            );

            // JSON fields
            formData.append(
                "list",
                JSON.stringify(this.especialidad_json.list)
            );
            formData.append(
                "encuestas_asignadas",
                JSON.stringify(this.especialidad_json.encuestas_asignadas)
            );
            formData.append(
                "eliminar_archivos",
                JSON.stringify(this.eliminar_archivos)
            );

            // Files
            // Files (New approach: send JSON metadata)
            for (let i = 0; i < this.archivos_nuevos.length; i++) {
                 formData.append("archivos_adjuntos[" + i + "]", JSON.stringify(this.archivos_nuevos[i]));
            }
            // Deleted files
            for (let i = 0; i < this.eliminar_archivos.length; i++) {
                formData.append("eliminar_archivos[" + i + "]", this.eliminar_archivos[i]);
            }

            axios
                .post("", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    window.history.back();
                })
                .catch((error) => {
                    console.log(error);
                    location.reload();
                })
                .then(() => {
                    this.buttonDisable = false;
                });
        },
        eliminar(index) {
            this.list.splice(index, 1);
        },
        filtrar_vacio(element, index) {
            if (element.establecimientos.length == 0) {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "Los establecimientos No." +
                        (index + 1) +
                        " no pueden quedar vacios!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }
            if (element.estrategia == "") {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "La estrategia No." +
                        (index + 1) +
                        " no puede quedar vacia!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }
            if (element.tipo_citas.length == 0) {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "Los Tipo Cita No." +
                        (index + 1) +
                        " no pueden quedar vacios!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }

            return true;
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
    background: #adadad;
}

.multiselect__tag-icon:after {
    color: black;
}

.multiselect__option--highlight {
    background: #707070;
}

.swal2-container {
    z-index: 999999999 !important;
}

.dropzone .dz-preview .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
